// src/components/layout/Dashboard.js
// ✅ VERSÃO ATUALIZADA - Largura maior para componentes
import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import { tokens } from '../../theme/tokens';

function Dashboard({ children, currentScreen, onNavigate, spotQueue, clearQueue, onShowClock, player }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const sidebarWidth = sidebarCollapsed ? '60px' : '260px';

  const [, forceUpdate] = useState(0)
  useEffect(() => {
    const observer = new MutationObserver(() => forceUpdate(n => n + 1))
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    })
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    document.documentElement.style.setProperty('--sidebar-width', sidebarWidth);
    return () => {
      document.documentElement.style.removeProperty('--sidebar-width');
    };
  }, [sidebarWidth]);

  return (
    // App shell em grid: o player é uma linha do layout (não flutua sobre o conteúdo).
    // Coluna da sidebar em `auto` acompanha a largura real (inclusive durante a transição
    // de colapso); linha do player em `auto` colapsa a 0 quando não há player.
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'auto minmax(0, 1fr)',
      gridTemplateRows: 'minmax(0, 1fr) auto',
      gridTemplateAreas: '"sidebar main" "sidebar player"',
      height: '100dvh',
      overflow: 'hidden',
      background: tokens.bgBase(),
      '--sidebar-width': sidebarWidth,
    }}>
      {/* Sidebar */}
      <div style={{ gridArea: 'sidebar', minHeight: 0, display: 'flex' }}>
        <Sidebar
          currentScreen={currentScreen}
          onNavigate={onNavigate}
          collapsed={sidebarCollapsed}
          onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
          spotQueue={spotQueue}
          clearQueue={clearQueue}
          onShowClock={onShowClock}
        />
      </div>

      {/* Main Content Area — único container que rola */}
      <div style={{
        gridArea: 'main',
        minWidth: 0,
        minHeight: 0,
        overflowY: 'auto',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}>
        {/* Content */}
        <div
          className="main-content"
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            padding: '0 clamp(16px, 4vw, 48px)',
          }}
        >
          {children}
        </div>
      </div>

      {/* Player — em fluxo normal na área "player" */}
      {player && (
        <div style={{ gridArea: 'player', minWidth: 0 }}>
          {player}
        </div>
      )}
    </div>
  );
}

export default Dashboard;
